module.exports = __webpack_public_path__ + "static/media/castle1.e3f9a7fe.jpg";